import { getServiceInstance } from "./base.service";
import { getToken } from "libraries/amplify.library";
import { FumigationCompanyPayload } from "./fumigationCompany.types";

const BASE_URL = (process.env.REACT_APP_BASE_URL || '').replace(/\/$/, '');

export const updateFumigationCompanyService = async (payload: FumigationCompanyPayload) => {
    try {
        const authToken = getToken()

        const response = await getServiceInstance().put(
            `${BASE_URL}/fumigator-details`,
            payload,
            {
                headers: {
                    Authorization: `Bearer ${authToken}`
                }
            }
        );
        return response.data;
    } catch (error) {
        console.error("Error updating fumigation company:", error);
        throw error;
    }
}
